<template>
  <section>
    <nav class="breadcrumb is-small nav-breadcrumbs" aria-label="breadcrumbs">
      <ul>
        <li><a href="#">Women</a></li>
        <li><a href="#">Clothing</a></li>
        <li class="is-active">
          <a href="#" aria-current="page">
            <span> {{ this.selectedSubmenu }} </span>
          </a>
        </li>
      </ul>
    </nav>
    <div v-if="shapeToken || styleNumber">
      <button
        class="button is-success shape-btn"
        @click="
          active = false;
          isShapeWizardModalActive = true;
        "
      >
        <span>Shape {{ this.displayStyleNumber() }}</span>
      </button>
    </div>
    <div v-else>
      <button
        class="button is-success shape-btn"
        @click="
          active = false;
          isShapeWizardModalActive = true;
        "
      >
        Shop my Shape
      </button>
    </div>
    <b-modal :active.sync="isShapeWizardModalActive">
      <!-- <ShapeWizard v-on:shape-selected="shapeSelected"/> -->
      <ShapeGallerySelector
        v-on:shape-selected="shapeSelected"
        v-on:shape-cleared="shapeCleared"
      />
    </b-modal>
    <h6 class="designer-title">Designers</h6>
    <ul slot="content">
      <li
        v-for="collection in getCollectionsByType(this.selectedSubmenu)"
        :key="collection.id"
        class="collection-name"
      >
        <label class="container">
          <input
            type="checkbox"
            :id="collection.id"
            v-model="selectedCollection"
            :value="collection"
            v-on:change="selectCollections($event)"
          />
          &nbsp;{{ collection.name }}
          <span class="checkmark"></span>
        </label>
      </li>
    </ul>
    <br/>
    <button class="button is-light is-small" @click="loadAllProducts()">Show All</button>
  </section>
</template>

<script>
// import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import _ from "lodash";
import ShapeGallerySelector from "@/components/ShapeGallerySelector";

export default {
  name: "RetailerNavBar",
  components: {
    // BulmaAccordion,
    // BulmaAccordionItem,
    ShapeGallerySelector,
  },
  props: {
    collections: Array,
    firstCollection: Object,
    styleNumber: String,
    selectedSubmenu: String,
    addCollection: Boolean,
  },
  data: function () {
    return {
      selectedCollection: [],
      selectedProductType: null,
      shapeToken: null,
      isShapeWizardModalActive: false,
      active: false,
    };
  },
  mounted() {
    this.shapeToken = this.styleNumber;
  },
  created() {
    this.shapeToken = this.styleNumber;
    setTimeout(() => {
      this.active = true;
    }, 5000);
  },
  methods: {
    shapeSelected(shapeTokenSelected) {
      this.shapeToken = shapeTokenSelected;
      this.$toast.open({
        message: "Sorting Collection based on Shape Intelligence",
        type: "is-success",
      });
      setTimeout(() => {
        this.$emit("shape-selected", this.shapeToken);
      }, 1000);
      setTimeout(() => {
        this.active = true;
      }, 8000);
    },
    displayStyleNumber() {
      switch (this.shapeToken) {
        case "red":
          return "A";
        case "purple":
          return "D";
        case "orange":
          return "B";
        case "green":
          return "E";
        case "blue":
          return "C";
        default:
          return "F";
      }
    },
    shapeCleared() {
      this.shapeToken = null;
      this.$emit("shape-cleared");
    },
    loadAllProducts() {
      this.selectedCollection = [];
      window.scrollTo(0, 0)
      this.$emit("load-initial");
    },
    selectCollections: function (e) {
      this.$emit("collection-selected", this.selectedCollection);
    },
    getCollectionsByType(productType) {
      return _.filter(this.collections, { product_type: productType });
    },
    selectProductType: function (productType) {
      this.selectedProductType = productType;
      this.$emit("product-type-selected", productType);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-bottom: 1px black solid;
}

li.collection-name {
  line-height: 2rem;
  a {
    color: black;
    &:hover {
      text-decoration: underline;
    }
  }
}

button.shape-btn {
  margin-bottom: 4%;
  width: 100%;
}

.highlight {
  border-top: 5px green solid;
}
.nav-breadcrumbs {
  padding-top: 0.6rem;
  margin-bottom: 1rem;
}

// Custom checkbox styles
.container {
  display: block;
  position: relative;
  padding-left: 25px;
  font-size: 0.8rem;
  // margin-bottom: 12px;
  cursor: pointer;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  margin-top: 0.4rem;
  border: 1px solid rgb(182, 182, 182);
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #4eafff;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark::after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark::after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.designer-title{
  padding-bottom: .5rem;
}
</style>
